module.exports = __webpack_public_path__ + "img/stakebody_stopped.a7ff86f0.svg";